import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LabelsModule } from '@core/components/labels/labels.module';
import { StatusModule } from '@core/components/status/status.module';
import { PipesModule } from '@core/pipes/pipes.module'

import { MessagesModule } from '@core/components/messages/messages.module';
import { HelpersModule } from '@core/components/helpers/helpers.module';
import { CommonsModule } from '@core/components/commons/commons.module';
import { FilesModule } from '@core/components/files/files.module';
import { SignedFilesModule } from '@core/components/signed-files/signed-files.module';

import { VersionsDetailsContentMainComponent } from './main/main.component';
import { VersionsDetailsContentMessagesComponent } from './messages/messages.component';


import { VersionsModule } from '@core/components/versions/versions.module';
import { FilesListModule } from '@core/components/files/lists/lists.module';
import { CorePdfViwerModule } from '@core/components/pdf/pdf.module';

import { VersionsDetailsContentInfoComponent } from './info/info.component';
import { LayoutModule } from '@core/components/layout/layout.module';
import { VersionsDetailsContentFilesNotesComponent } from './files-notes/files-notes.component';
import { VersionsDetailsContentPreviewFileMainComponent } from './preview-file-main/preview-file-main.component';
import { VersionsDetailsMessagesVersionShareFeedbackComponent } from './messages-version-share-feedback/messages-version-share-feedback.component';


@NgModule({
    imports: [
        CommonModule,
        LabelsModule,
        StatusModule,
        MessagesModule,
        HelpersModule,
        CommonsModule,
        FilesModule,
        PipesModule,
        LayoutModule,
        VersionsModule,
        FilesListModule,
        CorePdfViwerModule,
        SignedFilesModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        VersionsDetailsContentMainComponent,
        VersionsDetailsContentMessagesComponent,
        VersionsDetailsContentInfoComponent,
        VersionsDetailsContentFilesNotesComponent,
        VersionsDetailsContentPreviewFileMainComponent,
        VersionsDetailsMessagesVersionShareFeedbackComponent,
    ],
    exports: [
        VersionsDetailsContentMainComponent,
        VersionsDetailsContentPreviewFileMainComponent,
    ],

})
export class VersionsDetailsContentModule { }